
export default {
  data: () => ({
    isCalendlyActive: false,
    titleArgument: `Pourquoi avoir un site web <span class="font-clash font-bold text-purple-brand">bien référencé&nbsp;?</span>`,
    webArguments: [
      {
        title: "Multipliez vos opportunités commerciales",
        text: "80% des gens cherchent des pros sur Google.",
        img: require("~/assets/img/picto-pc.svg"),
      },
      {
        title: "Gagnez la confiance de vos prospects",
        text: "Être bien référencé améliore votre capital confiance.",
        img: require("~/assets/img/picto-medal.svg"),
      },
      {
        title: "Démarquez-vous de vos concurrents",
        text: "Montrez que vous êtes le meilleur dans votre secteur.",
        img: require("~/assets/img/picto-flex.svg"),
      },
    ],

    arguments2: [
      {
        img: "argument-ref-1.png",
        title: "Créer une stratégie de contenu",
        text: "Créez régulièrement du contenu optimisé de qualité qui plaît à Google et à vos clients.",
        alt: "Créer une stratégie de contenu",
      },
      {
        img: "argument-ref-2.png",
        title: "Optimiser son site web",
        text: "Optimisez les performances de votre site et assurez une maintenance de qualité.",
        alt: "Optimiser son site web",
      },
      {
        img: "argument-ref-3.png",
        title: "Intégrer une stratégie netlinking",
        text: "Améliorez votre popularité aux yeux de Google en étant recommandé par des sites de confiance.",
        alt: "Intégrer une stratégie netlinking",
      },
    ],

    itemsList: [
      {
        title: "Rédaction de pages optimisées pour le SEO",
        text: "Nos rédacteurs créent sur votre site internet des pages optimisées pour grimper dans les résultats de recherche Google.",
      },
      {
        title: "Optimisation de l’existant",
        text: "Nos équipes retravaillent et optimisent le contenu déjà existant sur votre site internet.",
      },
      {
        title: "Amélioration des performances",
        text: "Nous optimisons la vitesse de chargement de votre site internet pour des performances optimales, valorisées par Google.",
      },
      {
        title: "Stratégie de popularité",
        text: "Nous définissons les meilleurs sites pour vous recommander et créons entre 8 et 16 liens renvoyant vers votre site internet.",
      },
    ],

    reviews: [
      {
        text: "Merci beaucoup à toute l'équipe qui m'accompagne avec professionnalisme à passer à une autre étape de ma communication.",
        author: "Elise haas",
      },
      {
        text: "Super agence en communication ! Création d'une page web qui correspond à ma demande et un conseiller au top. Merci ALEO !",
        author: "K.B HOME-SERVICES",
      },
      {
        text: "Je suis content de leurs services. Toujours à l'écoute et prêts à nous aider. Merci à toute l'équipe.",
        author: "Y Toitures",
      },
      {
        text: "Le travail réalisé pour le référencement est très sérieux, les équipes sont professionnelles et l'agence fait preuve d'une grande rigueur. Je recommande chaleureusement.",
        author: "Agence Alsacienne de l'Or et Numismatique",
      },
    ],

    itemsListTeam: [
      {
        title: "Suivi des appels",
        text: "Observez en temps réel le retour sur investissement de votre stratégie SEO.",
      },
      {
        title: "Rapport en ligne",
        text: "Suivez en temps réel les performances de votre référencement naturel.",
      },
      {
        title: "Un chargé de projet SEO dédié",
        text: "Bénéficiez des conseils et du savoir-faire d’un expert SEO dédié à votre projet.",
      },
    ],

    price: {
      price: 249,
      text: "Escaladez facilement les résultats de recherche Google !",
    },

    reviewCollab: {
      author: "Maxence - Expert en référencement naturel",
      text: "Je multiplie vos opportunités commerciales grâce au SEO",
      img: "maxence.png",
      alt: "Référenceur ALEO",
    },

    timeline: {
      surtitle: "Nos experts SEO vous accompagnent de A à Z",
      title: `Votre stratégie de visibilité en <span class="font-clash font-bold">6 étapes</span>&nbsp;?`,
      steps: [
        {
          img: "seo-step-1.png",
          title: "Audit de préparation",
          text: "Nos équipes sélectionnent les mots-clés les plus pertinents pour votre activité et définissent un plan adapté pour atteindre vos objectifs.",
          alt: "Audit de préparation",
        },
        {
          img: "web-step-2.png",
          title: "Optimisation de votre site",
          text: "Nos équipes interviennent sur votre site internet pour optimiser son contenu, sa vitesse de chargement et sa structure.",
          alt: "Optimisation de votre site",
        },
        {
          img: "web-step-3.png",
          title: "Création de contenu",
          text: "Pour booster vos résultats, nos équipes s’occupent de la rédaction et de la création de pages construites pour optimiser l’efficacité de votre référencement.",
          alt: "Création de contenu",
        },
        {
          img: "web-step-4.png",
          title: "Stratégie de netlinking",
          text: "Nous mettons en place une stratégie de netlinking en choisissant des sites pertinents et en créant des liens de confiance vers votre site internet.",
          alt: "Stratégie de netlinking",
        },
        {
          img: "seo-step-5.png",
          title: "Maintenance et mises à jour",
          text: "Nous intervenons sur vos contenus pour un site dynamique qui s’adapte aux exigences de Google. Tous les 12 mois, nous rafraîchissons l’intégralité des contenus de votre site internet.",
          alt: "Maintenance et mises à jour",
        },
        {
          img: "web-step-6.png",
          title: "Suivi et accompagnement",
          text: "Nos équipes vous tiennent informé de chaque action effectuée sur votre site internet, et effectuent avec vous le suivi de vos objectifs.",
          alt: "Suivi et accompagnement",
        },
      ],
    },

    faq: [
      {
        question: "Qu’est-ce que le référencement naturel ?",
        answer: `<p class="pb-4">Le <strong>référencement naturel</strong>, aussi connu sous le nom de SEO, est l'ensemble des techniques visant à améliorer la position de votre site internet dans les <strong>résultats de recherche Google</strong>. Autrement dit, il s'agit d'optimiser la visibilité de votre site internet de manière organique, sans avoir à recourir à la publicité payante.</p>
  <p class="pb-4">Le référencement naturel comprend l'<strong>optimisation</strong> de différents aspects de votre site web, tant au niveau <strong>technique</strong> que du <strong>contenu</strong>. Cela inclut l'utilisation de <strong>mots-clés pertinents</strong>, l'optimisation de la structure du site, l'amélioration de la <strong>vitesse de chargement</strong>, la création de contenus de qualité et le développement de <strong>liens externes</strong> organiques.</p>
  <p class="pb-4">L'objectif principal du référencement naturel est d'améliorer la <strong>visibilité</strong> d'un site web dans les <strong>résultats de recherche</strong>, ce qui permet d'attirer un trafic qualifié et d'augmenter le nombre de visiteurs. En se classant parmi les <strong>premiers résultats pour des mots-clés pertinents</strong>, un site a plus de chances d'être visité et de <strong>générer du trafic organique</strong>.</p>
  <p>Le référencement naturel est un processus continu qui nécessite une surveillance et une adaptation constantes aux <strong>algorithmes des moteurs de recherche</strong>. Il peut également prendre du temps pour obtenir des résultats significatifs, car le classement d'un site web dépend de nombreux facteurs et de la concurrence existante sur ces mots-clés.</p>`,
        isCollapsed: false,
      },
      {
        question: "Comment choisir une agence SEO ?",
        answer: `<p class="pb-4">Bien choisir votre <strong>agence SEO</strong> est primordial pour assurer les meilleurs résultats ! Pour bien choisir votre agence SEO, assurez-vous que celle-ci à une solide expérience et a déjà travaillé avec des professionnels de votre secteur. Elle doit également proposer une gamme de services complète : <strong>optimisations SEO, référencement local, optimisation de votre site web et netlinking</strong>.</p>
  <p>Assurez-vous également que celle-ci propose un accompagnement et un suivi tout au long de la durée de votre contrat. Les résultats d’une stratégie SEO étant sur le moyen et sur le long terme, il est important que vous puissiez choisir un partenaire de confiance pour avoir le meilleur retour sur investissement possible.</p>`,
        isCollapsed: false,
      },
      {
        question: "Pourquoi faire appel à une agence SEO ?",
        answer: `<p class="pb-4">Faire appel à une <strong>agence SEO</strong> lorsque l’on est à son compte est essentiel pour améliorer votre visibilité sur les moteurs de recherche. A part si vous êtes <strong>expert SEO</strong>, une <strong>agence SEO</strong> comme ALEO vous apportera l’expertise nécessaire pour optimiser votre site web, augmenter son trafic et son <strong>positionnement sur Google</strong>.</p>
  <p>Passer par une agence spécialisée pour votre référencement naturel vous permettra d’optimiser vos résultats et d’avoir un meilleur <strong>retour sur investissement</strong>.</p>`,
        isCollapsed: false,
      },
      {
        question: "Combien coûte une agence SEO ?",
        answer: `<p>Le coût d’une <strong>agence SEO</strong> varie en fonction de plusieurs facteurs : l’importance de votre projet, la concurrence dans votre secteur, et les services spécifiques dont vous avez besoin. Certaines agences proposent des forfaits horaires et d’autres des tarifs mensuels. Si c’est la première fois que vous souhaitez passer par une agence SEO, nous vous conseillons de vous diriger vers des agences qui proposent des forfaits mensuels comme <strong>ALEO</strong>. Vous pourrez ainsi mieux estimer le retour sur investissement de votre campagne.</p>`,
        isCollapsed: false,
      },
      {
        question: "Pourquoi faire du référencement naturel ?",
        answer: `<p class="pb-4">Mettre en place une stratégie de <strong>référencement naturel (SEO)</strong> est essentiel pour augmenter votre <strong>visibilité</strong> sur les moteurs de recherche comme <strong>Google</strong>. Une bonne stratégie SEO vous permettra d’attirer un trafic qualifié, d’améliorer le classement de votre site internet sur <strong>Google</strong> et de renforcer votre <strong>image de marque</strong>. En optimisant votre contenu et en utilisant des <strong>mots-clés pertinents</strong>, vous pourrez atteindre votre public cible sans avoir à payer pour des publicités.</p>
        <p>Il est à noter que le référencement naturel est une stratégie à moyen et long terme qui génèrera des résultats durables pour votre entreprise.</p>`,
        isCollapsed: false,
      },
      {
        question: "Comment optimiser son référencement naturel ?",
        answer: `<p class="pb-4">Un bon référencement naturel repose sur <strong>3 piliers</strong> : stratégie de <strong>contenu</strong>, <strong>performances</strong> et <strong>netlinking</strong>. Pour commencer, vous ou votre <strong>agence SEO</strong> doit effectuer une recherche de <strong>mots-clés</strong> pertinents pour votre secteur. Il faudra ensuite créer du contenu informatif de qualité intégrant ces mots-clés de manière naturelle.</p>
        <p class="pb-4">Ensuite, vous devez optimiser votre site internet : <strong>vitesse de chargement, compatibilité mobile et structure Hn</strong>. Enfin, vous ou votre <strong>agence SEO</strong> doit mettre en place une stratégie de <strong>netlinking</strong> efficace avec des liens entrants provenant de site réputés afin d’optimiser les résultats de votre <strong>stratégie SEO</strong>.</p>
        <p>Un suivi régulier est indispensable pour pouvoir mettre en place des actions correctives et affirmer votre positionnement.</p>`,
        isCollapsed: false,
      },
      {
        question: "Fournissez-vous des rapports de performance SEO réguliers ?",
        answer: `<p class="pb-4">Absolument ! Si vous choisissez ALEO pour <strong>développer votre site internet professionnel</strong>, vous aurez accès à un tableau de performances vous permettant de suivre l'évolution de votre positionnement SEO et l'état de santé de votre site internet.</p>
        <p>De plus, un expert dédié à votre projet sera toujours disponible pour vous accompagner et assurer un suivi optimal de votre projet web.</p>`,
        isCollapsed: false,
      },
      {
        question:
          "Quel est le délai avant de voir les résultats d’une stratégie SEO ?",
        answer: `<p class="pb-4">Le délai avant de voir des <strong>résultats en SEO</strong> varie, mais il faut généralement compter entre 3 à 6 mois pour observer des améliorations significatives en <strong>termes de référencement Google</strong>. Ce délai dépend de plusieurs facteurs : la concurrence dans votre secteur, la qualité de votre contenu, l'état actuel de votre site internet et les efforts d'optimisation <strong>SEO</strong> mis en place. Le <strong>référencement naturel</strong> est une stratégie à long terme nécessitant une optimisation continue et des ajustements réguliers pour maintenir et améliorer les résultats en termes de trafic et de <strong>visibilité</strong>.</p>`,
        isCollapsed: false,
      },
    ],
  }),

  head() {
    return {
      title: "Agence de référencement naturel (SEO) - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Vous cherchez à améliorer votre visibilité sur le web et à attirer un trafic organique qualifié ? L'agence SEO ALEO peut vous aider à atteindre vos objectifs.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence référencement naturel (SEO) - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Vous cherchez à améliorer votre visibilité sur le web et à attirer un trafic organique qualifié ? L'agence SEO ALEO peut vous aider à atteindre vos objectifs.",
        },
      ],
    };
  },

  mounted() {
    const video = this.$refs.video;

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          video.play();
          io.unobserve(entry.target);
        }
      });
    });

    io.observe(video);
  },

  methods: {
    activeCalendly() {
      this.isCalendlyActive = false;
      this.$nextTick(() => {
        this.isCalendlyActive = true;
      });
    },
  },
};
